import { render } from "./List.vue?vue&type=template&id=7983bec4&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=7983bec4&lang=scss&scoped=true"
import "./List.vue?vue&type=style&index=1&id=7983bec4&lang=scss"
script.render = render
script.__scopeId = "data-v-7983bec4"

export default script